export default "__VITE_ASSET__87edd5c6__"